export const ProductReducer = (state = [], action) => {
    switch (action.type) {
        case 'GET_PRODUCT':
            return action.item;
        case 'REMOVE_PRODUCT':
            return state.filter((e,i) => i !== action.index);
        default:
            return state
    }
}